<template>
    <div class="widget-calendar">
        <dashboardCard heading='Gc Memory Usage' :data1="gcMemoryAllocated" :data2="gcMemoryPromoted"
            :data3="gcOverHead">
        </dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./DashboardCard.vue";
export default {
    name: "GcMemoryUsage",
    components: {
        dashboardCard
    },
    data() {
        return {
            gcMemoryAllocated: {},
            gcMemoryPromoted: {},
            gcOverHead: {},
        };
    },
    methods: {
        getGcOverHead(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.gcOverHead.value = (response.server.data[0].value).toFixed(2) + '%';
                    this.gcOverHead.name = 'OverHead';
                    this.gcOverHead.description = 'Percentage of CPU time spent in garbage collection'
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getGcMemoryPromoted(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const bytes = response.server.data[0].value;
                    this.gcMemoryPromoted.value = this.formatBytes(bytes);
                    this.gcMemoryPromoted.name = 'Promoted in GB';
                    this.gcMemoryPromoted.description = 'Amount of memory moved from the Young Gen to the Old Gen during GC cycles';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getGcMemoryAllocated(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const bytes = response.server.data[0].value;
                    this.gcMemoryAllocated.value = this.formatBytes(bytes);
                    this.gcMemoryAllocated.name = 'Allocated in GB';
                    this.gcMemoryAllocated.description = 'Total amount of memory allocated in the JVM heap';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatBytes(bytes) {
            const gigabytes = bytes / (1024 ** 3);
            const formattedGB = gigabytes.toFixed(2);
            return formattedGB;
        }
    },
    mounted() {
        this.getGcMemoryAllocated("GC_MEMORY_ALLOCATED");
        this.getGcMemoryPromoted("GC_MEMORY_PROMOTED");
        this.getGcOverHead("GC_OVERHEAD");
    }
};
</script>